import { LayoutProps } from '@sport1/types/web'

export const getSections = (layoutData?: LayoutProps): string => {
    if (!layoutData) return ''
    const adTargeting = layoutData?.meta?.ad?.targeting
    const sections: string[] = []
    if (adTargeting?.adUnit3) {
        sections.push(adTargeting.adUnit3)
    }
    if (adTargeting?.adUnit4) {
        sections.push(adTargeting.adUnit4)
    }
    return sections.join(',')
}
